import styled from 'styled-components';
import ChevronDownGray from '../../../../assets/icons/ChevronDownGray.svg';

const ButtonContainer = styled.button`
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 9px;
  align-self: ${({ device }) => (device === 'mobile' ? 'center' : 'flex-end')};
  margin: ${({ margin }) => margin};
  cursor: pointer;
  text-decoration: none;
  :hover {
    text-decoration: ${({ device }) => (device === 'desktop' ? 'underline' : 'none')};
  }
`;

const Chevron = styled.span`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  margin-bottom: ${({ device }) => (device === 'mobile' ? '0' : '2px')};
  background-image: url(${ChevronDownGray});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  transform: ${({ active }) => `rotateX(${active ? '0deg' : '180deg'})`};
  transition: all 0.3s ease;
  cursor: pointer;
`;

export { ButtonContainer, Chevron };
